module.exports = __webpack_public_path__ + "img/充电枪.6f745a28.png";